// tslint:disable:max-line-length
// tslint:disable:no-unused-expression

import { Directive, EventEmitter, HostListener, HostBinding, Output, Input, OnInit, OnDestroy } from '@angular/core';
import { FileManager } from '../source/fileManager.core';
import { FileUploader } from '../source/fileUploader.core';
import { FileManagerOptions } from '../interface';
export class FileSelectDirective implements OnInit, OnDestroy {
     role = 'input';
     type = 'file';
public fileHoverStart: EventEmitter<any> = new EventEmitter<any>();
public fileHoverEnd: EventEmitter<any> = new EventEmitter<any>();
public fileAccepted: EventEmitter<FileManager[]> = new EventEmitter<FileManager[]>();
public fileRejected: EventEmitter<Error> = new EventEmitter<Error>();
public fileOptions: FileManagerOptions;
public uploader: FileUploader;
private _InputFile: any = null;
private _files: FileManager[];
public constructor() { }
/**
 * @return {?}
 */
public ngOnInit() {
        this._files = [];
    }
/**
 * @return {?}
 */
public ngOnDestroy() {
        if (this._files.length > 0) {
            for (let /** @type {?} */ _file of this._files) {
                if (_file instanceof FileManager) {
                    if (!_file.isUploaded()) {
                        _file.cancel();
                        this.uploader.removeFile(_file);
                    }
                }
            }
        }
    }
/**
 * @param {?} event
 * @return {?}
 */
public onChange(event: Event): void {
        // Update our data
        this._InputFile = this.getEventTarget(event);

        if (this._InputFile.files.length === 0) {
            this._InputFile  = null;
            return;
        }

        let /** @type {?} */ filesData: FileList = this._InputFile.files;

        this.readFile(filesData);

        this.fileAccepted.emit(this._files);

        // Finished with the file
        this._InputFile  = null;

        // Don't let it continue
        this.preventAndStopEventPropagation(event);
    }
/**
 * @param {?} event
 * @return {?}
 */
private preventAndStopEventPropagation(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
    }
/**
 * @param {?} _files
 * @return {?}
 */
private readFile(_files: FileList): void {
        let /** @type {?} */ fmObject: FileManager;
        for (let /** @type {?} */ i = 0; i < _files.length; i++) {
            let /** @type {?} */ file = _files[i];
            try {
                fmObject = new FileManager(file, this.fileOptions, this.uploader);
            } catch ( /** @type {?} */e) {
                if (e.status === 100) {
                    this.fileRejected.emit(e);
                } else {
                    this.fileRejected.emit(e);
                }
                throw new Error('Something goes wrong e: ' + e.message);
            }

            (fmObject.inQueue) && this._files.push(fmObject);
        }
    }
/**
 * @param {?} event
 * @return {?}
 */
private getEventTarget(event: Event | any): any {
        return event.target;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    // Selector required in component HTML
    // tslint:disable-next-line:directive-selector
    selector: '[ng2File2Select]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'role': [{ type: HostBinding, args: ['attr.role', ] },],
'type': [{ type: HostBinding, args: ['attr.type', ] },],
'fileHoverStart': [{ type: Output },],
'fileHoverEnd': [{ type: Output },],
'fileAccepted': [{ type: Output },],
'fileRejected': [{ type: Output },],
'fileOptions': [{ type: Input },],
'uploader': [{ type: Input },],
'onChange': [{ type: HostListener, args: ['change', ['$event'], ] },],
};
}

function FileSelectDirective_tsickle_Closure_declarations() {
/** @type {?} */
FileSelectDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FileSelectDirective.ctorParameters;
/** @type {?} */
FileSelectDirective.propDecorators;
/** @type {?} */
FileSelectDirective.prototype.role;
/** @type {?} */
FileSelectDirective.prototype.type;
/** @type {?} */
FileSelectDirective.prototype.fileHoverStart;
/** @type {?} */
FileSelectDirective.prototype.fileHoverEnd;
/** @type {?} */
FileSelectDirective.prototype.fileAccepted;
/** @type {?} */
FileSelectDirective.prototype.fileRejected;
/** @type {?} */
FileSelectDirective.prototype.fileOptions;
/** @type {?} */
FileSelectDirective.prototype.uploader;
/** @type {?} */
FileSelectDirective.prototype._InputFile;
/** @type {?} */
FileSelectDirective.prototype._files;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
